import {Component, EventEmitter, Input, OnInit, Output, OnDestroy} from '@angular/core';
import {OrdSped} from '../../../_models/OrdSped';
import {Subscription} from 'rxjs';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {MessageConfirm} from '../../../_helpers/message-confirm.service';
import {SaveMessage} from '../../../_helpers/save-message';
import {ModalController} from '@ionic/angular';
import {OrdinispedizioniService} from '../../../_services/ordinispedizioni.service';
import {SpedizioneUpdateSendComponent} from '../spedizione-update-send/spedizione-update-send.component';

@Component({
    selector: 'app-spedizione-locale-item',
    templateUrl: './spedizione-locale-item.component.html',
    styleUrls: ['./spedizione-locale-item.component.scss'],
    standalone: false
})
export class SpedizioneLocaleItemComponent  implements OnInit, OnDestroy {
  @Input() spedizione: OrdSped;
  @Input() updateEnable: boolean;
  @Output()  spedizioneSended = new EventEmitter<OrdSped>();
  isDeletePending = false;
  dataOggi = new Date().toISOString();
  subscription: Subscription;
  today = new Date().toISOString();
  constructor(
    private organizzazioniService: OrganizzazioniService,
    private messageConfirm: MessageConfirm,
    private saveMessage: SaveMessage,
    private modalCtrl: ModalController,
    private spedizioniService: OrdinispedizioniService) { }

  ngOnInit() {
    this.subscription = this.spedizioniService.lastOrdSpedUpdated.subscribe((_spedizione: OrdSped) => {
      if (_spedizione == null) {
        return false;
      }
      if (!this.spedizione.isLoading &&
        _spedizione.numRegistraz > 0 &&
        this.spedizione.idDocumento === _spedizione.idDocumento &&
        this.spedizione.idRiga === _spedizione.idRiga) {
        this.spedizione = _spedizione;
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  deleteSpedizione = (spedizione: OrdSped) => {
    if (this.isDeletePending) {
      return;
    }
    // TODO: allineare alla delete ordini: oggi la cancellazione spedizione non rimuove
    // esplicitamente gli eventuali eventi collegati lato backend.
    void this.messageConfirm
      .presentAlert(`Confermi di eliminare la spedizione ${spedizione.numRegistraz} (${spedizione.idDocumento}.${spedizione.idRiga})?`, () => {
        this.isDeletePending = true;
        this.spedizioniService.deleteOrdineSpedizione(this.organizzazioniService.organizzazioneId, spedizione.idDocumento,
          spedizione.idRiga)
          .then(() => {
            this.spedizione.onQueue = true;
            this.saveMessage.messageInfo('Richiesta di eliminazione della spedizione inviata con successo.');
          })
          .catch(() => {
            this.isDeletePending = false;
            this.spedizione.onQueue = false;
            this.saveMessage.messageError("Ci sono problemi con l'eliminazione della spedizione.");
          });
      });
  };

  closeSpedizione = (spedizione: OrdSped) => {
    if (this.isDeletePending) {
      return;
    }
    void this.messageConfirm.presentAlert(`Confermi di terminare la spedizione?`, () => {
      spedizione.onQueue = true;
      spedizione.statoSpedizione = 3;
      spedizione.flgTerminato = true;
      this.spedizioniService.updateOrdineSpedizione(spedizione)
        //.then(results => this.spedizioniService.resetOrdSpedGroup())
        .catch(() => this.saveMessage.messageError('Ci sono problemi con chiusura'))
        .finally(() => spedizione.onQueue = false);       
    });
  };

  selectSpedizione = (spedizione: OrdSped) => {
    if (this.isDeletePending) {
      return;
    }
    if (this.updateEnable && !spedizione.isLoading) {
      void this.openModal(spedizione);
    } else {
      this.spedizioneSended.emit(spedizione);
    }
  };

  async openModal(element: OrdSped) {
    const modal = await this.modalCtrl.create({
      component: SpedizioneUpdateSendComponent,
      backdropDismiss: false,cssClass: 'custom-modal',
      componentProps: { spedizione: element, data: this.dataOggi },
    });
    await modal.present();
    const {role} = await modal.onWillDismiss();
    if (role === 'save' || role === 'send') {
    }
  }
}
